"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spacer = require("./Spacer.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Spacer = function Spacer(_ref) {
  var bottom = _ref.bottom,
    breakpoints = _ref.breakpoints,
    children = _ref.children,
    className = _ref.className,
    left = _ref.left,
    noBottom = _ref.noBottom,
    noLeft = _ref.noLeft,
    noRight = _ref.noRight,
    noTop = _ref.noTop,
    right = _ref.right,
    size = _ref.size,
    top = _ref.top;
  if (children) {
    return /*#__PURE__*/_react.default.createElement(_Spacer.SpacerWithChildren, {
      bottom: bottom,
      breakpoints: breakpoints,
      className: className,
      left: left,
      noBottom: noBottom,
      noLeft: noLeft,
      noRight: noRight,
      noTop: noTop,
      right: right,
      size: size,
      top: top
    }, children);
  }
  return /*#__PURE__*/_react.default.createElement(_Spacer.SpacerNoChildren, {
    breakpoints: breakpoints,
    className: className,
    size: size
  });
};
Spacer.defaultProps = {
  size: 'md',
  breakpoints: {},
  top: false,
  bottom: false,
  left: false,
  right: false,
  noTop: false,
  noBottom: false,
  noLeft: false,
  noRight: false
};
var _default = Spacer;
exports.default = _default;